import { useSettings } from '@/hooks/state/useSettings';
import { UserBadge } from './UserBadge';
export const UserInfo = () => {
  const {
    settings
  } = useSettings();
  let name = `${settings?.user.first_name}${settings?.user.last_name ? ` ${settings?.user.last_name}` : ''}`;
  if (!name && settings?.user.email) {
    name = settings?.user.email;
  }
  return <div className="flex w-full flex-row items-center justify-between gap-4" data-sentry-component="UserInfo" data-sentry-source-file="UserInfo.tsx">
      <div className="flex flex-col items-start gap-0.5 overflow-hidden leading-none">
        <h3 className="max-w-full self-start overflow-hidden text-ellipsis text-nowrap font-heading font-semibold text-gray-950 text-lg xl:text-xl dark:text-gray-50">
          {name}
        </h3>
        <UserBadge data-sentry-element="UserBadge" data-sentry-source-file="UserInfo.tsx" />
      </div>
    </div>;
};